module.exports = __webpack_public_path__ + "img/防爆认证.28b62085.svg";